/**
 * A fraction of the usable viewport height — the dynamic viewport minus the
 * on-screen keyboard (--kb; see lib/keyboard.ts). Use instead of raw `dvh` in
 * inline styles, which CSS can't retarget. Keep in sync with the
 * viewportHeight() helper in tailwind.config.js (h-dvh, max-h-dvh-N, ...).
 */
export function viewportHeight(fraction = 1): string {
  return fraction === 1
    ? 'calc(100dvh - var(--kb, 0px))'
    : `calc((100dvh - var(--kb, 0px)) * ${fraction})`;
}
